import {ThemeDefinition} from '../interfaces/theme-definition';

export const themeDefinitions: ThemeDefinition[] = [
  {id: 't4f', name: 'Twict4Fiber Light', class: null, dark: false, includedContractorIds: ['dev', 'test', 'acc', 'reg']},
  {id: 't4f-dark', name: 'Twict4Fiber Dark', class: 'theme-dark', dark: true, includedContractorIds: ['dev', 'test', 'acc', 'reg']},

  {id: 'bam', name: 'BAM Telecom', class: 'theme-bam', includedContractorIds: ['dev', 'test', 'acc', 'reg', 'bam']},
  {id: 'art', name: 'Artemis ITS', class: 'theme-art', includedContractorIds: ['dev', 'test', 'acc', 'reg', 'art']},
  {id: 's30', name: 'Solutions30', class: 'theme-s30', includedContractorIds: ['dev', 'test', 'acc', 'reg', 's30']},
  {id: 'fcop', name: 'FiberCop', class: 'theme-fcop', includedContractorIds: ['dev', 'test', 'acc', 'reg', 'fcop']},
  {id: 'baas', name: 'Baas', class: 'theme-baas', includedContractorIds: ['dev', 'test', 'acc', 'reg', 'baas']},
  {id: 'vwtd', name: 'VolkerWessels Telecom Deutschland', class: 'theme-vwtd', includedContractorIds: ['dev', 'test', 'acc', 'reg', 'vwtd']},

  {id: 'default', name: 'Twict4Fiber Light', class: null, dark: false, excludedContractorIds: ['dev', 'test', 'acc', 'reg']},
  {id: 'default-dark', name: 'Twict4Fiber Dark', class: 'theme-dark', dark: true, excludedContractorIds: ['dev', 'test', 'acc', 'reg']}
];
